import {ArtisticObjectListing} from '../../admin/artisticobjects/types/ArtisticObject';
import {SearchCriteria, SearchQuery} from '../types/SearchCriteria';
import {handleError} from '../../common/utils/errorHandling';
import httpClient from '../../common/services/httpClient';

class SearchService {
  public async searchArtisticObjects(criteria: SearchCriteria = {}): Promise<ArtisticObjectListing[]> {
    const searchQuery: SearchQuery = { criteria };

    return handleError(
      () => httpClient.post<ArtisticObjectListing[]>('/search', searchQuery),
      'Error searching artistic objects:',
      () => []
    );
  }

  public async getArtisticObjectsByPlaceId(placeId: string): Promise<ArtisticObjectListing[]> {
    const criteria: SearchCriteria = {
      places: [placeId]
    };

    return this.searchArtisticObjects(criteria);
  }

  public async getArtisticObjectsByParentId(parentId: string): Promise<ArtisticObjectListing[]> {
    return handleError(
      () => httpClient.get<ArtisticObjectListing[]>(`/artistic-objects/parent/${parentId}`),
      'Error fetching child artistic objects:',
      () => []
    );
  }
}

const searchService = new SearchService();
export default searchService;
